module.exports = __webpack_public_path__ + "img/av_eagle.ffb9de18.png";